import React, { useContext, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button
} from 'reactstrap';

import { AuthContext } from '../../context/AuthContext';
import { TipoServicoContext } from '../../context/TipoServicoContext';
import { CreateTipoServicoType } from '../../context/hooks/useTipoServico';
import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated?: () => void;
}

export const CreateTipoServicoModal: React.FC<Props> = ({
    isOpen,
    toggle,
    onCreated
}) => {
    const { objUserTk } = useContext(AuthContext);
    const { createTipoServico } = useContext(TipoServicoContext);

    const [formData, setFormData] = useState<CreateTipoServicoType>({
        name: '',
        value: 0,
        empresaId: objUserTk.EmpresaId
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createTipoServico(formData);
        if (ok) {
            onCreated?.();
            toggle();
            setFormData({ name: '', value: 0, empresaId: objUserTk.EmpresaId });
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar novo serviço</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="name">
                            Tipo de serviço
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Ex: Album de fotos, Cerimônia, etc."
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="value">
                            Valor padrão
                        </Label>
                        {/* <Input
                            className="form-control-alternative"
                            id="value"
                            name="value"
                            type="number"
                            value={formData.value}
                            onChange={handleChange}
                            placeholder="Ex: 100, 200, etc."
                            required
                        /> */}
                        <CurrencyInput
                            name="value"
                            value={formData.value}
                            onValueChange={v => setFormData(prev => ({ ...prev, value: v }))}
                            placeholder="R$ 0,00"
                        />
                    </FormGroup>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Criar Tipo de Serviço
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default CreateTipoServicoModal;